export default __webpack_public_path__ + "static/media/blender.b96901d1.svg";